import { eEstadoMaestro } from "../common/enumModel";
import { IFilterProyectoModel } from "../interfaces/proyectos/IFilterProyectoModel";

export class FilterProyectoModel implements IFilterProyectoModel {    
    idProyecto: number[];
    proyecto: string;
    idEstado: eEstadoMaestro;
    page: number;
    pageSize: number;
    
    constructor(){
        this.idProyecto = new Array<number>();
        this.proyecto = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}